import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let PartnersPageThunk = createAsyncThunk(
	"Partners/PartnersPageThunk",
	async (_, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			const url = `https://api.raj.com.sa/api/public/partners`;

			const res = await axios.get(url, {
				headers: {
					Locale: localStorage.getItem("language") || navigator?.languages?.[1],
				},
			});

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data.data);
		}
	}
);
